import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'

import { ReactComponent as UserSVG } from 'shared/img/user-svg.svg'
import { selectIsUserAuthenticated, selectUserData } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'

import { useModalContext } from 'components/HOC/withModalQuery/ModalContext'

import Button from 'components/UIKit/Button/Button'
import { ReactComponent as BonusBalanceIcon } from './icons/bonus-balance.svg'
import { ReactComponent as WalletBalanceIcon } from './icons/wallet-balance.svg'

import './UserBlock.scss'

const b = block('user-block')

const UserBlock: React.FC = () => {
  const modal = useModalContext()
  const locale = useSelector(selectLocaleDict, shallowEqual).profile
  const user = useSelector(selectUserData, shallowEqual)
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)

  const handleProfileClick = () => {
    modal.pushNewModal(MODAL_ROUTE_URLS.PROFILE('tab'))()
  }

  return (
    <section className={b()}>
      {isAuth ? (
        <button
          className={b('user')}
          onClick={handleProfileClick}
          type="button"
        >
          <div className={b('icon-wrapper')}>
            <UserSVG className={b('icon')} />
          </div>
          <div className={b('info')}>
            <span className={b('info-username')}>{user?.username}</span>
            <div className={b('balance-row')}>
              <WalletBalanceIcon className={b('balance-icon')} />
              <span className={b('info-amount')}>{`${user?.balance} ${user?.currency}`}</span>
            </div>
            <div className={b('balance-row')}>
              <BonusBalanceIcon className={b('balance-icon')} />
              <span className={b('info-amount')}>{`${user?.bonusBalance} B`}</span>
            </div>
          </div>
        </button>
      ) : (
        <div className={b('buttons-wrapper')}>
          {/* <div className={b('btn-container')}>
            <Button text={locale.signUp} callback={modal.pushNewModal(MODAL_ROUTE_URLS.SIGN_UP())} />
          </div> */}
          <div className={b('btn-container')}>
            <Button text={locale.login} callback={modal.pushNewModal(MODAL_ROUTE_URLS.SIGN_IN())} />
          </div>
        </div>
      )}
    </section>
  )
}

export default UserBlock
